/**
 * アクセス解析の同意状態を localStorage で管理する
 * キー: analytics-consent, 値: 'accepted' | 'rejected'
 */

const STORAGE_KEY = 'analytics-consent';

export type AnalyticsConsentValue = 'accepted' | 'rejected';

/**
 * 同意状態を取得する
 * @returns true: 同意済み, false: 拒否済み, null: 未選択
 */
export function getAnalyticsConsent(): boolean | null {
  try {
    const value = localStorage.getItem(STORAGE_KEY);
    if (value === 'accepted') return true;
    if (value === 'rejected') return false;
    return null;
  } catch {
    return null;
  }
}

/**
 * 同意状態を保存する
 * @param accepted true: 同意, false: 拒否
 */
export function setAnalyticsConsent(accepted: boolean): void {
  try {
    localStorage.setItem(STORAGE_KEY, accepted ? 'accepted' : 'rejected');
  } catch (e) {
    console.warn('Failed to save analytics consent:', e);
  }
}

export { STORAGE_KEY };
